"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductSpecsMultiColumnContainerItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * Local Imports
 */

const Columns = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Columns",
  class: "pl-c1z0bzx8"
});
const ImageWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageWrapper",
  class: "pl-i2r5vvp"
});
const Image = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "Image",
  class: "pl-iztzjto"
});

/**
 * ProductSpecsMultiColumnContainerItem Component.
 *
 * @param {Object} props React props
 * @param {Object} props.attribution Destructrued Image Object
 * @param {String} props.title Attribution Title
 * @returns {React.ReactElement} MultiColumnItem Component
 * @public
 */

function ProductSpecsMultiColumnContainerItem({
  attribution = {},
  title
}) {
  const renderAttribution = () => {
    if (/*#__PURE__*/_react.default.isValidElement(attribution)) {
      return attribution;
    }
    const {
      url,
      altText
    } = attribution;
    return /*#__PURE__*/_react.default.createElement(Image, {
      src: url,
      alt: altText
    });
  };
  return /*#__PURE__*/_react.default.createElement(Columns, {
    "data-cy": "columns"
  }, /*#__PURE__*/_react.default.createElement(ImageWrapper, {
    "data-cy": "multi-column-image"
  }, renderAttribution()), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 1,
    text: title,
    "data-cy": "paragraph"
  }));
}
ProductSpecsMultiColumnContainerItem.propTypes = {
  attribution: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  title: _propTypes.default.string
};